import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import { Typography, Box } from '@mui/material';

function DemoItem({ demo }) {
  const theme = useTheme();

  const containerStyle = {
    display: 'flex',
    alignItems: 'baseline', // Aligns text cleanly
    gap: '16px',            // Space between title and date
  };

  const titleStyle = {
    fontSize: '18px',
    lineHeight: 1.6,
    fontWeight: 500,
  };

  const dateStyle = {
    fontSize: '14px',
    color: theme.palette.text.secondary, // Gray color for date
    fontStyle: 'italic',
    minWidth: '100px' // Optional: ensures dates align vertically if you want a column look
  };

  // 1. RENDER LINK (Interactive)
  if (demo.to) {
    return (
      <Box sx={containerStyle}>
        <Link
          to={demo.to}
          style={{
            textDecoration: 'none',
            color: theme.palette.primary.main, // Link color
            ...titleStyle
          }}
          onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
          onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
        >
          {demo.title}
        </Link>
        
        <Typography component="span" sx={dateStyle}>
          {demo.date}
        </Typography>
      </Box>
    );
  }

  // 2. RENDER COMING SOON (Non-interactive)
  return (
    <Box sx={containerStyle}>
      <Typography 
        component="span" 
        sx={{ ...titleStyle, color: theme.palette.text.primary, opacity: 0.5 }}
      >
        {demo.title}
      </Typography>
      
      <Typography component="span" sx={{ ...dateStyle, opacity: 0.5 }}>
        {demo.date}
      </Typography>
    </Box>
  );
}

export default DemoItem;